import * as fromShared from '../../../shared';

/**************************************************************************************************/
/*   File: /src/app/stores/actions/ui/actions.ts                                                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';
import { User } from '@siag/js-egov-authentication';

/**
 * The ui action types enum
 */
export enum UiActionTypes {
    LANGUAGE_CHANGE_ACTION = '[UI][Language] Change language action',
    LANGUAGE_CHANGE_SUCCESS_ACTION = '[UI][Language] Change language success action',
    LANGUAGE_CHANGE_FAILURE_ACTION = '[UI][Language] Change language failure action',

    SET_LOGGED_USER = '[UI] Set the logged user',
    UNSET_LOGGED_USER = '[UI] Unset the logged user',

    LOAD_DOSSIER_STATUS = '[UI] Load dossier status',
    LOAD_DOSSIER_STATUS_SUCCESS = '[UI] Load dossier status success',

    LOAD_PLAN_TYPES = '[UI] Load plan types',
    LOAD_PLAN_TYPES_SUCCESS = '[UI] Load plan types success',
    LOAD_PLAN_TYPES_FAIL = '[UI] Load plan types fail',

    LOAD_AMBITI_BY_PLAN = '[UI] Load ambiti by plan',
    LOAD_AMBITI_BY_PLAN_SUCCESS = '[UI] Load ambiti by plan success',
    LOAD_AMBITI_BY_PLAN_FAIL = '[UI] Load ambiti by plan fail',

    LOAD_ALL_AMBITI = '[UI] Load all ambiti',
    LOAD_ALL_AMBITI_SUCCESS = '[UI] Load all ambiti success',
    LOAD_ALL_AMBITI_FAIL = '[UI] Load all ambiti fail',

    LOAD_GEO_DATA_TYPES = '[UI] Load geo data types',
    LOAD_GEO_DATA_TYPES_SUCCESS = '[UI] Load geo data types success'
}

/**
 * The language change action
 */
export class LanguageChangeAction implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.LANGUAGE_CHANGE_ACTION;

    /**
     * The constructor
     * @param payload the payload 
     */
    constructor(public payload: { isoCode: string }) { }
}

/**
 * The language change action
 */
export class LanguageChangeSuccessAction implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.LANGUAGE_CHANGE_SUCCESS_ACTION;

    /**
     * The constructor
     * @param payload the payload 
     */
    constructor(public payload: { isoCode: string }) { }
}


/**
 * The language change action
 */
export class LanguageChangeFailureAction implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.LANGUAGE_CHANGE_FAILURE_ACTION;

    /**
     * The constructor
     * @param payload the payload 
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}

/**
 * The set logged user
 */
export class SetLoggedUser implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.SET_LOGGED_USER;

    /**
     * The constructor
     * @param payload the payload 
     */
    constructor(public payload: { user: User }) { }
}

/**
 * The set logged user
 */
export class UnSetLoggedUser implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.UNSET_LOGGED_USER;

    /**
     * The constructor
     * @param payload the payload
     */
    constructor(public payload: {isoCode: string}) { }
}

/**
 * Load the dossier status collection
 */
export class LoadDossierStatus implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_DOSSIER_STATUS;

    /**
     * The constructor
     */
    constructor(public payload: {isoCode: string}) { }
}

/**
 * Load the dossier status success collection
 */
export class LoadDossierStatusSuccess implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_DOSSIER_STATUS_SUCCESS;

    /**
     * The constructor
     * @param payload The status array
     */
    constructor(public payload: { status: fromShared.models.DossierStatus[] }) { }
}
/**
 * Load plan types
 */
export class LoadPlanTypes implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_PLAN_TYPES;

    /**
     * The constructor
     */
    constructor() { }
}

/**
* Load plan types success
*/
export class LoadPlanTypesSuccess implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_PLAN_TYPES_SUCCESS;

    /**
     * The constructor
     * @param payload the plan types array
     */
    constructor(public payload: { planTypes: fromShared.models.PlanType[] }) { }
}

/**
* Load plan types fail action
*/
export class LoadPlanTypesFail implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_PLAN_TYPES_FAIL;

    /**
     * The constructor
     * @param payload contianint the message
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}

/**
* Load all ambiti
*/
export class LoadAllAmbiti implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_ALL_AMBITI;
    /**
     * The constructor
     */
    constructor() { }
}

/**
* Load all ambiti success
*/
export class LoadAllAmbitiSuccess implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_ALL_AMBITI_SUCCESS;
    /**
     * The constructor
     * @param payload the ambiti array
     */
    constructor(public payload: { ambiti: fromShared.models.Ambito[] }) { }
}

/**
* Load all ambiti fail
*/
export class LoadAllAmbitiFail implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_ALL_AMBITI_FAIL;

    /**
     * The constructor
     * @param payload containing the message
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}

/**
 * Load ambiti by plan
 */
export class LoadAmbitiByPlan implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_AMBITI_BY_PLAN;

    /**
     * The constructor
     * @param payload Payload containing plancode
     */
    constructor(public payload: { planCode: string }) { }
}

/**
* Load ambiti by plan success
*/
export class LoadAmbitiByPlanSuccess implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_AMBITI_BY_PLAN_SUCCESS;

    /**
     * The constructor
     * @param payload the ambiti array
     */
    constructor(public payload: { ambiti: fromShared.models.Ambito[] }) { }
}

/**
* Load ambiti by plan fail
*/
export class LoadAmbitiByPlanFail implements Action {
    /**
    * The type
    */
    readonly type = UiActionTypes.LOAD_AMBITI_BY_PLAN_FAIL;

    /**
     * The constructor
     * @param payload containing the message
     */
    constructor(public payload: { message: fromShared.models.Message }) { }
}
/**
* Load geo data types
*/
export class LoadGeoDataTypes implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.LOAD_GEO_DATA_TYPES;

    /**
    * Construct the Load geo data types 
    */
    constructor() { }
}
/**
 * Load geo data types
 */
export class LoadGeoDataTypesSuccess implements Action {
    /**
     * The type
     */
    readonly type = UiActionTypes.LOAD_GEO_DATA_TYPES_SUCCESS;

    /**
     * Construct the Load geo data types success action
     * @param payload The array of geo data types
     */
    constructor(public payload: { fileTypes: fromShared.models.GeoFileType[] }) {
    }
}



/**
 * The file action type
 */
export type Actions =
    LanguageChangeAction |
    LanguageChangeSuccessAction |
    LanguageChangeFailureAction |
    SetLoggedUser |
    UnSetLoggedUser |
    LoadDossierStatus |
    LoadDossierStatusSuccess |
    LoadPlanTypes |
    LoadPlanTypesSuccess |
    LoadPlanTypesFail |
    LoadAllAmbiti |
    LoadAllAmbitiSuccess |
    LoadAllAmbitiFail |
    LoadAmbitiByPlan |
    LoadAmbitiByPlanSuccess |
    LoadAmbitiByPlanFail |
    LoadGeoDataTypes |
    LoadGeoDataTypesSuccess;
